import moment from 'moment'

const vuelidate_attributes = {
  dob: 'Geboortedatum',
  password_valid: 'Wachtwoord',
  email: 'E-mailadres',
  initials: 'Voorletters',
  letterhead: 'Aanhef',
  'phone.mobile': 'Telefoon',
  'phone.landline': 'Telefoon 2',
  cc_email: 'CC Email',
  zipcode: 'Postcode',
  housenumber: 'Huisnummer',
  city: 'Stad',
  income: 'Inkomen',
  lastname: 'Achternaam',
  'currentSettings.communication': 'Hoe wilt u getipt worden',
  'currentSettings.rent.min': 'Minimum huur',
  'currentSettings.rent.max': 'Maximum huur'
}
const vuelidate_messages = {
  required: '{attribute} is een verplicht veld',
  email: '{attribute} moet een geldig e-mailadres zijn',
  dobAboveEighteen: '{attribute} moet tenminste 16 jaar geleden zijn',
  passwordIsValid: '{attribute} moet voldoen aan de vereisten',
  dutchPhone: '{attribute} moet een geldig Nederlands nummer zijn',
  dutchZipcode: '{attribute} moet een geldige Nederlandse postcode zijn'
}



function dobAboveEighteen (value) {
  let calcDate = moment(value, 'YYYY-MM-DD')
  if (!calcDate._isValid) {
    return false
  }
  return calcDate.diff(moment(), 'years') <= -15
}
function dobAboveTwentythree (value) {
  let calcDate = moment(value, 'YYYY-MM-DD')
  if (!calcDate._isValid) {
    return false
  }
  return calcDate.diff(moment(), 'years') < -22
}

function validDate (value) {
  let calcDate = moment(value, 'YYYY-MM-DD')
  return calcDate._isValid
}

function dutchPhone (value) {
  if (value === '') {
    return true
  }
  return /^(?:0|(?:\+|00) ?31 ?)(?:(?:[1-9] ?(?:[0-9] ?){8})|(?:6 ?-? ?[1-9] ?(?:[0-9] ?){7})|(?:[1,2,3,4,5,7,8,9]\d ?-? ?[1-9] ?(?:[0-9] ?){6})|(?:[1,2,3,4,5,7,8,9]\d{2} ?-? ?[1-9] ?(?:[0-9] ?){5}))$/.test(value)
}

function dutchZipcode (value) {
  if (value === '') {
    return true
  }
  return /^\d{4} ?[a-z]{2}$/i.test(value)
}

function passwordIsValid (value) {
  if(value) {
    return true
  }
  return false
}

function validGUID (value) {
  return /^([0-9a-fA-F]{8})-(([0-9a-fA-F]{4}\-){3})([0-9a-fA-F]{12})$/i.test(value)
}

export {
  vuelidate_attributes,
  vuelidate_messages,
  dobAboveEighteen,
  dobAboveTwentythree,
  dutchPhone,
  dutchZipcode,
  validDate,
  passwordIsValid,
  validGUID
}
